// Resolved price list for the signed-in owner - GET /v1/billing/rates.
// Rendered by the Pricing dialog (Settings > Billing > Usage & Limits).
const action = "BILLING_RATES";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = ()         => ({ type: REQUEST });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
